import React, { FC, useState } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { SmallButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';

import { EikaModal } from '../../components/EikaModal';
import FavoriteAccountImg from '../../components/FavoriteAccount/FavoriteAccountImg';
import FavoriteAccountModal from '../../components/FavoriteAccountModal/FavoriteAccountModal';
import useTranslation from '../../hooks/useTranslation';

import favoriteAccountHeart from '../../resources/select-favorite-account-heart.svg';
import './FavoriteAccount.scss';

interface Props {
    className?: string;
    error: RequestExceptionWithResponse | null;
}

const FavoriteAccountSelector: FC<Props> = ({ className, error }) => {
    const [showStartSelectFavoriteAccountModal, setShowStartSelectFavoriteAccountModal] = useState<boolean>(false);
    const [showFavoriteAccountModal, setShowFavoriteAccountModal] = useState<boolean>(false);
    const translated = useTranslation();

    return (
        <div className={`frontpage-select-favorite-account ${className}`}>
            <div className="frontpage-select-favorite-account__container">
                <img src={favoriteAccountHeart} alt="" />
                <h1>{translated.favoriteAccount.favoriteAccountCardTitle}</h1>
                <SmallButton
                    onClick={() => setShowStartSelectFavoriteAccountModal(!showStartSelectFavoriteAccountModal)}
                >
                    {translated.favoriteAccount.frontpageFavoriteAccountButtonText}
                </SmallButton>
                {error && (
                    <ErrorLabel
                        severe
                        className="frontpage-select-favorite-account__container--error"
                        text={translated.commonErrors.paymentFailed}
                        icon={IconTypes.UTROPSTEGN_24}
                    />
                )}
            </div>
            <EikaModal
                id="frontpage-select-favorite-account-modal"
                setOpen={setShowStartSelectFavoriteAccountModal}
                open={showStartSelectFavoriteAccountModal}
                className="frontpage-select-favorite-account__modal"
            >
                <h2>{translated.favoriteAccount.favoriteAccountCardTitle}</h2>
                <FavoriteAccountImg borderRadius />
                <div className="frontpage-select-favorite-account__modal-footer">
                    <p>{translated.favoriteAccount.frontpageFavoriteAccountModalText}</p>
                    <StandardButton onClick={() => setShowFavoriteAccountModal(true)}>
                        {translated.favoriteAccount.favoriteAccountCardTitle}
                    </StandardButton>
                </div>
                <FavoriteAccountModal
                    isSubModal
                    showModal={showFavoriteAccountModal}
                    setShow={setShowFavoriteAccountModal}
                />
            </EikaModal>
        </div>
    );
};

export default FavoriteAccountSelector;
